import type { ReactNode } from 'react'

export const UserRole = {
  Customer: 'customer',
  Admin: 'admin',
  Vendor: 'vendor',
} as const

export type UserRole = (typeof UserRole)[keyof typeof UserRole]

export type AuthUser = {
  id: string
  role: UserRole
  vendorId: string | null
  name: string | null
  phone: string | null
  email: string | null
  phoneVerified: boolean
  emailVerified: boolean
  isActive: boolean
}

export type AuthSession = {
  accessToken: string
  refreshToken: string
  user: AuthUser
}

export type LoginFormState = {
  email: string
  password: string
}

export const AUTH_STORAGE_KEY = 'maaliondoor.vendor.auth.v1'

export const EMPTY_LOGIN_FORM: LoginFormState = {
  email: '',
  password: '',
}

export const LOGIN_COPY = {
  title: 'Welcome back',
  subtitle: 'Sign in to manage products, your shop, and orders.',
  panelEyebrow: 'Vendor portal',
  panelTitle: 'Keep every bouquet ready to go.',
  panelBody:
    'Add products, keep your shop location current, and stay on top of express fulfillment — all in one place.',
  emailLabel: 'Email',
  passwordLabel: 'Password',
  emailPlaceholder: 'you@florist.com',
  passwordPlaceholder: 'Enter your password',
  submit: 'Sign in',
  nonVendor: 'This account does not have vendor access.',
  missingVendor: 'This vendor account is not linked to a business yet.',
  inactive: 'This account is inactive.',
  genericError: 'Could not sign in. Check your email and password.',
} as const

export type AuthGateProps = {
  children: ReactNode
}
